var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inviter-container-1"},[(_vm._child)?_c('inner-children-renderer',{attrs:{"children":_vm._child}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }